import { useDisplayTimezone } from "../lib/DateDisplayContext";
import { createDateFormatter } from "../lib/dateTime";

export function DateTimeText({
  value,
  options = {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  },
  fallback = "\u2014",
}: {
  value: Date | string | number | null | undefined;
  options?: Intl.DateTimeFormatOptions;
  fallback?: string;
}) {
  const timezone = useDisplayTimezone();
  const date = value == null ? null : new Date(value);
  return date && Number.isFinite(date.getTime())
    ? createDateFormatter(timezone, options).format(date)
    : fallback;
}
